import { getAuth, signOut } from "firebase/auth";


export function redirectIfNotLoggedIn(setShowCustomAlert, navigate, delay = 1000) {
  const auth = getAuth();
  setShowCustomAlert(true);
  const timeout = setTimeout(() => {
    const user = auth.currentUser;
    const userId = user?.uid;
    if (!userId) {
      navigate("/sign-in", { replace: true });
    } else {
      setShowCustomAlert(false);
    }
  }, delay);

  return () => clearTimeout(timeout);
}
